import { Injectable } from '@angular/core';
import { PdfExportCertificatesGeBaseService } from './pdf-export-certificates-ge-base.service';

@Injectable()
export class PdfExportCertificatesGeLevel2Service extends PdfExportCertificatesGeBaseService {

  protected needsManagementRepresentitiveSignature = true;
  constructor(
  ) {
    super()
  }

  protected getAuthorisingEngineerSignatureUrl(): string {
    return this.signatureUrlRauriMaguire;
  }

  protected getAuthorisingEngineerSignatureName(): string {
    return 'Rauri Maguire';
  }

  protected getManagementRepresentitiveSignatureUrl(): string {
    return this.signatureUrlGarySmith;
  }

  protected getManagementRepresentitiveSignatureName(): string {
    return 'Gary Smith';
  }

  protected fillInApprovedCodes(): void {
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('C', 56, 423); // D2C
    this.doc.text('C', 56, 439); // D3C
    this.doc.text('C', 56, 487); // D6C
    this.doc.text('C', 56, 539); // E1C
    this.doc.text('C', 56, 555); // E2C
    this.doc.text('C', 56, 627); // G1C
    this.doc.setFont('helvetica', 'normal');
  }
}
